var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"headline"},[_vm._v("Use our wizard to estimate your service needs...")]),_c('WizardUseCategory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }